import { createContext } from "react";
// src/contexts/drawer.ts
const DrawerContext = createContext({ position: "bottom" });
export { DrawerContext };

//# sourceMappingURL=drawer.js.map